
define('text!admin/index.html',[],function () { return '<div id="editor">\r\n    <!--ko router: { cacheViews:false }--><!--/ko-->\r\n</div>';});

